export default "__VITE_ASSET__IGywExKC__"